var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "review-likes" }, [
    _c("div", { staticClass: "review-likes__likes-title" }, [
      _vm._v("\n    " + _vm._s(_vm.title) + "\n  ")
    ]),
    _c("div", { staticClass: "review-likes__likes-buttons-wrap" }, [
      _c("div", { staticClass: "review-likes__likes-button-wrap" }, [
        _c(
          "button",
          {
            staticClass: "review-likes__likes-button like",
            on: {
              click: function($event) {
                return _vm.$emit("like")
              }
            }
          },
          [
            _c("f-sprite-icon", {
              attrs: { "icon-link": _vm.$options.icons.like.id }
            })
          ],
          1
        ),
        _c("div", { staticClass: "review-likes__likes-counter" }, [
          _vm._v("\n        " + _vm._s(_vm.likes) + "\n      ")
        ])
      ]),
      _c("div", { staticClass: "review-likes__likes-button-wrap" }, [
        _c(
          "button",
          {
            staticClass: "review-likes__likes-button dislike",
            on: {
              click: function($event) {
                return _vm.$emit("dislike")
              }
            }
          },
          [
            _c("f-sprite-icon", {
              attrs: { "icon-link": _vm.$options.icons.dislike.id }
            })
          ],
          1
        ),
        _c("div", { staticClass: "review-likes__likes-counter" }, [
          _vm._v("\n        " + _vm._s(_vm.dislikes) + "\n      ")
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }